"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function InfoIconWhite(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none" }, props, { children: [(0, jsx_runtime_1.jsx)("rect", { width: 16, height: 16, fill: "#fff", rx: 8 }), (0, jsx_runtime_1.jsx)("path", { fill: "#2E2A25", fillRule: "evenodd", d: "M7.989 5.778a.889.889 0 1 0 0-1.778.889.889 0 0 0 0 1.778Zm0 .889a.889.889 0 0 0-.889.889v3.555a.889.889 0 0 0 1.778 0V7.556a.889.889 0 0 0-.89-.89Z", clipRule: "evenodd" })] })));
}
exports.default = InfoIconWhite;
